import { createReducer } from 'redux-create-reducer'
import type { LineItems } from 'types/summary'
import {
  BILLING_PROVIDER_COMPONENTS_FAIL,
  BILLING_PROVIDER_COMPONENTS_LOAD,
  BILLING_PROVIDER_COMPONENTS_SUCCESS,
} from '@disco/constants/ActionTypes'
import type { ChargebeeAddOnDetailed } from '@disco/types/types/subscription'
import type { BillingProviderComponentsTypes } from '@disco/constants/billing-provider-components'
export type BillingProviderComponent = {
  external_handle: string
  external_id_us: number
  id: number
  plans: {
    external_id: string
    id: number
    name: string
  }[]
  term: 'annual' | 'monthly'
  type: BillingProviderComponentsTypes
  componentPreview: LineItems
}

type BillingProviderComponentState =
  | { [key in 'annual' | 'monthly']?: Record<string, BillingProviderComponent> }
  | null
  | undefined

export type BillingProviderComponentsState = {
  loading: boolean
  loaded: boolean
  error: Error | null | undefined
  plans: Record<string, LineItems | null | undefined>
  addons: Record<string, ChargebeeAddOnDetailed[]>
  chargebeePlans: object[]
  originals: Record<string, BillingProviderComponent>
  DSPrices: Record<string, Record<string, LineItems | null | undefined>>
  WMPrices: Record<string, Record<string, LineItems | null | undefined>>
  results: BillingProviderComponent[]
  user?: BillingProviderComponentState
  storage?: BillingProviderComponentState
  watermarking?: BillingProviderComponentState
  discovery_suite?: BillingProviderComponentState
}
const initialState: BillingProviderComponentsState = {
  loading: false,
  loaded: false,
  error: null,
  plans: {},
  addons: {},
  chargebeePlans: [],
  originals: {},
  DSPrices: {},
  WMPrices: {},
  results: [],
}
export const billingProviderComponentsReducer = createReducer<
  BillingProviderComponentsState,
  any
>(initialState, {
  [BILLING_PROVIDER_COMPONENTS_LOAD]() {
    return { ...initialState, loading: true, loaded: false, error: null }
  },

  [BILLING_PROVIDER_COMPONENTS_SUCCESS](_state, action) {
    return {
      loading: false,
      loaded: true,
      error: null,
      ...action.components,
    }
  },

  [BILLING_PROVIDER_COMPONENTS_FAIL](_state, action) {
    return {
      ...initialState,
      loading: false,
      loaded: true,
      error: action.error,
    }
  },
})
